import React from 'react';
import './StatusBadge.css';

/**
 * StatusBadge Component - Consistent status indicator display
 * 
 * @param {string} status - Status value ('Active', 'Inactive', 'Pending', 'Approved', 'Rejected', 'Submitted', 'Completed', 'Cancelled')
 * @param {string} variant - Visual variant: 'default' | 'outlined' | 'filled'
 * @param {string} size - Badge size: 'small' | 'medium' | 'large'
 */
const StatusBadge = ({ 
  status = 'Active', 
  variant = 'default',
  size = 'medium'
}) => {
  const getStatusClass = () => {
    const normalizedStatus = status.toLowerCase();
    
    if (normalizedStatus === 'active' || normalizedStatus === 'approved' || normalizedStatus === 'submitted' || normalizedStatus === 'completed') {
      return 'success';
    }
    if (normalizedStatus === 'inactive' || normalizedStatus === 'cancelled') {
      return 'danger';
    }
    if (normalizedStatus === 'pending') {
      return 'warning';
    }
    if (normalizedStatus === 'rejected') {
      return 'error';
    }
    return 'default';
  };

  const statusClass = getStatusClass();

  return (
    <span className={`status-badge status-${statusClass} variant-${variant} size-${size}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
